import { AxiosPromise } from 'axios';
import request, { downloadPost } from '../network';

// 获取活动列表
export function list(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/list`,
    method: 'post',
    data,
  });
}

// 获取建档礼活动v2列表
export function benefitListV2(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/benefit/list`,
    method: 'post',
    data,
  });
}

// 获取建档礼活动v2详情
export function benefitDetailV2(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/benefit/detail`,
    method: 'get',
    params,
  });
}

// 获取建档礼活动v2可选满减券
export function benefitCouponOptionsV2(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/benefit/couponOptions`,
    method: 'get',
    params,
  });
}

// 创建建档礼活动v2
export function benefitCreateV2(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/benefit/create`,
    method: 'post',
    data,
  });
}

// 编辑建档礼活动v2
export function benefitUpdateV2(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/benefit/update`,
    method: 'post',
    data,
  });
}

// 删除建档礼活动v2
export function benefitDeleteV2(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/benefit/delete`,
    method: 'post',
    data,
  });
}

// 查询活动投放二维码详情
export function queryActivityDeliveryLink(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/deliveryLink/query`,
    method: 'post',
    data,
  });
}

// 创建活动投放二维码
export function createActivityDeliveryLink(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/deliveryLink/create`,
    method: 'post',
    data,
  });
}

// 修改活动投放链接配置
export function updateActivityDeliveryLink(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/deliveryLink/update`,
    method: 'post',
    data,
  });
}

// 获取活动详情
export function detail(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/detail`,
    method: 'get',
    params,
  });
}

// 获取奖励列表
export function rewardList(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/couponConfig/list`,
    method: 'get',
    params,
  });
}

//创建活动
export function create(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/create`,
    method: 'post',
    data,
  });
}

//编辑活动
export function update(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/update`,
    method: 'post',
    data,
  });
}

//获取活动数据概览
export function overview(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/data/overview`,
    method: 'get',
    params,
  });
}

//获取活动数据
export function getData(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/data/trend`,
    method: 'get',
    params,
  });
}

//获取数据维度
export function getDimensions(): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/activity/data/dimensions`,
    method: 'get',
  });
}

// 埋点看板 - 归档渠道统计列表
export function archiveChannelStat(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/archiveChannelStat/list`,
    method: 'post',
    data,
  });
}

// 埋点看板 - 归档渠道统计导出
export function archiveChannelStatExport(data: any) {
  return downloadPost(`/member/royalcanin/admin/archiveChannelStat/export`, data);
}
